import { Button, Typography, message as antdMessage } from "antd"
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ContainerFull } from "../components"
import { createRun, previewRunId } from "../endpoints/runEndpoints"

export const MakeRun = (): JSX.Element => {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [previewLoading, setPreviewLoading] = useState(false)
    const [proposedRunId, setProposedRunId] = useState<number | null>(null)
    const [previewError, setPreviewError] = useState<string | null>(null)
    const [messageApi, contextHolder] = antdMessage.useMessage()

    // Parse plate IDs from query string
    const searchParams = new URLSearchParams(location.search)
    const platesParam = searchParams.get("plates")
    const plateIds = platesParam ? platesParam.split(",").map(id => Number(id)) : []

    useEffect(() => {
        let ignore = false
        const previewPlateIds = platesParam ? platesParam.split(",").map(id => Number(id)) : []

        if (previewPlateIds.length === 0) {
            setProposedRunId(null)
            setPreviewError(null)
            setPreviewLoading(false)
            return
        }

        setPreviewLoading(true)
        setPreviewError(null)

        previewRunId({ plateIds: previewPlateIds })
            .then((res) => {
                if (ignore) return
                if (res.code === 1000 && res.runId != null) {
                    setProposedRunId(res.runId)
                    setPreviewError(null)
                    return
                }

                setProposedRunId(null)
                setPreviewError(res.message || "Failed to determine run ID.")
            })
            .catch((err: any) => {
                if (ignore) return
                setProposedRunId(null)
                setPreviewError(err?.message || "Failed to determine run ID.")
            })
            .finally(() => {
                if (!ignore) {
                    setPreviewLoading(false)
                }
            })

        return () => {
            ignore = true
        }
    }, [platesParam])

    const handleCreateRun = async () => {
        setLoading(true)
        try {
            const res = await createRun({ plateIds })
            if (res && res.code === 1000) {
                messageApi.success(res.runId ? `Run ${res.runId} created successfully!` : "Run created successfully!")
                navigate("/admin/runs")
            } else {
                messageApi.error(res?.message ?? "Failed to create run.")
            }
        } catch (err: any) {
            messageApi.error(err?.message ?? "Failed to create run.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <ContainerFull style={{ fontFamily: '"Rubik", sans-serif' }}>
            {contextHolder}
            <Typography.Title style={{ fontSize: '1.6em', marginBottom: '1.2em' }}>
                {plateIds.length > 0 ? (
                    <>
                        <span style={{ fontSize: '1.2em' }}>
                            {plateIds.length === 1 ? "Create new run for plate: " : "Create new run for plates: "}
                        </span>
                        {plateIds.map((id, idx) => (
                            <React.Fragment key={id}>
                                <Typography.Link style={{ fontSize: '1.6em' }} onClick={() => navigate(`/admin/plate/${id}`)}>
                                    {id}
                                </Typography.Link>
                                <span style={{ fontSize: '1.6em' }}>{idx < plateIds.length - 1 ? ", " : ""}</span>
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    "No plates selected."
                )}
            </Typography.Title>
            {plateIds.length > 0 && (
                <Typography.Paragraph style={{ fontSize: '1.05em', marginBottom: '1.2em' }}>
                    {previewLoading ? (
                        <span style={{ color: '#888' }}>Checking run ID...</span>
                    ) : previewError ? (
                        <span style={{ color: '#ff4d4f' }}>Failed to determine run ID: {previewError}</span>
                    ) : proposedRunId != null ? (
                        <>
                            New run ID: <strong>{proposedRunId}</strong>
                        </>
                    ) : null}
                </Typography.Paragraph>
            )}
            <Button
                type="primary"
                disabled={plateIds.length === 0}
                loading={loading}
                onClick={handleCreateRun}
            >
                Confirm
            </Button>
            <Button
                style={{ marginLeft: 8 }}
                onClick={() => navigate("/admin/plates")}
            >
                Cancel
            </Button>
        </ContainerFull>
    )
}

export default MakeRun